module.exports = __webpack_public_path__ + "media/images/page/top/top_img_02-2f69adb205464d38c59fa335b701d57e.png";